const subscribers = new Set();

export const notificationBus = {
  subscribe: (fn) => {
    subscribers.add(fn);
    return () => subscribers.delete(fn);
  },
  notify: (message, severity = 'error') => {
    subscribers.forEach((fn) => fn({ message, severity }));
  },
};
